import React from "react";
import { Link } from "react-router-dom";
import { BrandMark, Wordmark } from "./BrandMark";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="relative border-t border-brand bg-[var(--brand-paper)]"
        >
            <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 py-12 sm:py-14">
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10">
                    <div className="max-w-[360px]">
                        <Link to="/" className="flex items-center gap-2.5">
                            <BrandMark size={30} />
                            <Wordmark />
                        </Link>
                        <p className="mt-4 text-[13.5px] leading-relaxed text-[var(--brand-muted-2)]">
                            A calmer way through conflict. Private by default,
                            neutral by design, and always on your side — both
                            of your sides.
                        </p>
                        <p className="mt-3 text-[12px] text-[var(--brand-muted)]">
                            A product of{" "}
                            <span className="font-medium text-[var(--brand-muted-2)]">
                                Tylegn Gaming and Entertainment, LLC
                            </span>
                            .
                        </p>
                    </div>

                    <nav
                        className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-[13.5px]"
                        aria-label="Footer navigation"
                    >
                        <FooterCol
                            title="Product"
                            links={[
                                { label: "How it works", href: "/#how-it-works" },
                                { label: "Features", href: "/#features" },
                                { label: "Use cases", href: "/#use-cases" },
                                { label: "FAQ", href: "/#faq" },
                            ]}
                        />
                        <FooterCol
                            title="Safety"
                            links={[
                                { label: "Safety & privacy", href: "/#safety" },
                                { label: "Crisis resources", href: "/#safety" },
                                { label: "Data & deletion", href: "/#safety" },
                            ]}
                        />
                        <FooterCol
                            title="Company"
                            links={[
                                { label: "Blog", to: "/blog" },
                                { label: "Support", to: "/support" },
                                { label: "Terms", to: "/terms" },
                                { label: "Privacy policy", to: "/privacy" },
                                { label: "EULA", to: "/eula" },
                                { label: "Contact", href: "mailto:support@tylegn.com" },
                            ]}
                        />
                    </nav>
                </div>

                <div className="divider-hair mt-10" />

                <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <p
                        data-testid="footer-disclaimer-text"
                        className="text-[12px] text-[var(--brand-muted)] max-w-[620px] leading-relaxed"
                    >
                        BetweenUs is a communication tool. It is not therapy,
                        legal advice, or crisis counseling. If you or someone
                        you know is in immediate danger, please contact local
                        emergency services.
                    </p>
                    <p className="text-[12px] text-[var(--brand-muted)]">
                        © {new Date().getFullYear()} Tylegn Gaming and
                        Entertainment, LLC. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}

function FooterCol({ title, links }) {
    return (
        <div>
            <p className="text-[11px] uppercase tracking-[0.18em] font-semibold text-[var(--brand-ink)]">
                {title}
            </p>
            <ul className="mt-3 space-y-2">
                {links.map((l) => {
                    const testId = `footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`;
                    if (l.to) {
                        return (
                            <li key={l.label}>
                                <Link
                                    to={l.to}
                                    className="text-[var(--brand-muted-2)] hover:text-[var(--brand-ink)] transition-colors"
                                    data-testid={testId}
                                >
                                    {l.label}
                                </Link>
                            </li>
                        );
                    }
                    return (
                        <li key={l.label}>
                            <a
                                href={l.href}
                                className="text-[var(--brand-muted-2)] hover:text-[var(--brand-ink)] transition-colors"
                                data-testid={testId}
                            >
                                {l.label}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
